import React from 'react';
import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import colors from '../constants/Colors';

export default function ArchivedUserWarning() {
  return (
    <Tooltip title="This employee is archived">
      <WarningOutlined
        style={{
          color: colors.ONTRACCR_RED,
          marginLeft: 5,
        }}
      />
    </Tooltip>
  );
}
